export default "__VITE_ASSET__meTJ32Td__"